import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HeaderService } from '../shared/header.service';
@Injectable()
export class AITeammatesService {
    private url = environment.urlpath;
    constructor(private http: HttpClient, private headerSrv: HeaderService) { }

    PostPrestonPromptToAI(formData:{company: string, name: string, source: string, title: string, id: number, company_url: string, userProfile?: any, 
Hubspot?: any}){
        const body:{
            company: string, 
            name: string, 
            source: string, 
            title: string, 
            id: number, 
            url: string, 
            userProfile?: any, 
            Hubspot?: any
        } = {
            company: formData.company,
            name: formData.name,
            source: formData.source,
            title: formData.title,
            id: formData.id,
            url: formData.company_url
        }
        if(formData.userProfile){
            body.userProfile = formData.userProfile;
        }
        if(formData.Hubspot){
            body.Hubspot = formData.Hubspot;
        }
        return this.http.post(`${this.url}/intranet/preston_prompt`, JSON.stringify(body), { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    PostRangerPromptToAI(formData:{source: string, id: number, transcript?: any[]}){
        const body:{ source: string, id: number, transcript?: any[]} = {
            source: formData.source,
            id: formData.id
        }
        if(formData.transcript && formData.transcript.length > 0){
            body.transcript = formData.transcript;
        }
        return this.http.post(`${this.url}/intranet/ranger_prompt`, JSON.stringify(body), { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    PostAriaPromptToAI(formData:{query: string}){
        const body: FormData = new FormData();
        body.append('query', formData.query);
        // Non-system Aria prompt execution (initiates a chat session)
        return this.http.post(`${this.url}/intranet/aria_prompt`, body, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    GetPrestonPrompts() {
        let Params = new HttpParams();
        Params = Params.append('system', 'true');
        return this.http.get(`${this.url}/intranet/preston_prompt`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
            catchError(this.headerSrv._errorHandler))
    }

    AddEditPrestonPrompt(action: string, body: any){
        if(action === 'add'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.post(`${this.url}/intranet/preston_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else if(action === 'update'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.put(`${this.url}/intranet/preston_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else {
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            const httpOptions = {
                headers: this.headerSrv.returnHeader(),
                body: JSON.stringify(body),
                params: Params
            };
            return this.http.delete(`${this.url}/intranet/preston_prompt`, httpOptions).pipe(catchError(this.headerSrv._errorHandler));
        }
    }
    GetRangerPrompts() {
        let Params = new HttpParams();
        Params = Params.append('system', 'true');
        return this.http.get(`${this.url}/intranet/ranger_prompt`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }
    AddEditRangerPrompt(action: string, body: any){
        if(action === 'add'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.post(`${this.url}/intranet/ranger_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else if(action === 'update'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.put(`${this.url}/intranet/ranger_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else {
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            const httpOptions = {
                headers: this.headerSrv.returnHeader(),
                body: JSON.stringify(body),
                params: Params
            };
            return this.http.delete(`${this.url}/intranet/ranger_prompt`, httpOptions).pipe(catchError(this.headerSrv._errorHandler));
        }
    }
    GetAriaPrompts() {
        let Params = new HttpParams();
        Params = Params.append('system', 'true');
        return this.http.get(`${this.url}/intranet/aria_prompt`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }
    AddEditAriaPrompt(action: string, body: any){
        if(action === 'add'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.post(`${this.url}/intranet/aria_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else if(action === 'update'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.put(`${this.url}/intranet/aria_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else {
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            const httpOptions = {
                headers: this.headerSrv.returnHeader(),
                body: JSON.stringify(body),
                params: Params
            };
            return this.http.delete(`${this.url}/intranet/aria_prompt`, httpOptions).pipe(catchError(this.headerSrv._errorHandler));
        }
    }
    GetVoraPrompts() {
        let Params = new HttpParams();
        Params = Params.append('system', 'true');
        return this.http.get(`${this.url}/intranet/aura_prompt`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    AddEditVoraPrompt(action: string, body: any){
        if(action === 'add'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.post(`${this.url}/intranet/aura_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else if(action === 'update'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.put(`${this.url}/intranet/aura_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else {
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            const httpOptions = {
                headers: this.headerSrv.returnHeader(),
                body: JSON.stringify(body),
                params: Params
            };
            return this.http.delete(`${this.url}/intranet/aura_prompt`, httpOptions).pipe(catchError(this.headerSrv._errorHandler));
        }
    }
    GetChasePrompts() {
        let Params = new HttpParams();
        Params = Params.append('system', 'true');
        return this.http.get(`${this.url}/intranet/chase_prompt`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }

    AddEditChasePrompt(action: string, body: any){
        if(action === 'add'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.post(`${this.url}/intranet/chase_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else if(action === 'update'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.put(`${this.url}/intranet/chase_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else {
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            const httpOptions = {
                headers: this.headerSrv.returnHeader(),
                body: JSON.stringify(body),
                params: Params
            };
            return this.http.delete(`${this.url}/intranet/chase_prompt`, httpOptions).pipe(catchError(this.headerSrv._errorHandler));
        }
    }
    GetAllPromptChannels(){
        return this.http.get(`${this.url}/intranet/prompt_channels`, {headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    PostChasePromptToAI(formCopy: {id: number,company: string, company_url: string, name: string, title: string ,transcript?: File[], transcript_text?: string, userProfile?: any, Hubspot?: any}){
        const body: {id: number, company: string, url: string, name: string, title: string, transcript?: File[], text?: string, userProfile?: any, Hubspot?: any} = {
            id: formCopy.id,
            company: formCopy.company,
            url: formCopy.company_url,
            name: formCopy.name,
            title: formCopy.title
        }

        if (formCopy.transcript && formCopy.transcript.length > 0) {
            body.transcript = formCopy.transcript;
        }
        
        if (formCopy.transcript_text) {
            body.text = formCopy.transcript_text;
        }
        if(formCopy.userProfile){
            body.userProfile = formCopy.userProfile;
        }
        if(formCopy.Hubspot){
            body.Hubspot = formCopy.Hubspot;
        }
        return this.http.post(`${this.url}/intranet/chase_prompt`, body, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    /**
     * Post Vora Prompt To AI
     * POST: /intranet/aura_prompt
     * Body: { query: string }
     * Non-system Vora prompt execution (initiates a chat session)
     * @param formData - Object containing the query string
     * @returns Observable with Vora chat response
     */
    PostVoraPromptToAI(formData:{query: string}){
        const body: any = { query: formData.query };
        return this.http.post(`${this.url}/intranet/aura_prompt`, JSON.stringify(body), { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    AiTeammatesFileUpload(fileData: File[]){
        const body: FormData = new FormData();
        fileData.forEach(file => {
            body.append('upload', file, file.name);
        });
        return this.http.post(`${this.url}/intranet/chat_upload`, body, { reportProgress: true, observe: 'events', headers: this.headerSrv.returnHeader() }).pipe(
            map((event) => {
                switch (event.type) {
                  case HttpEventType.UploadProgress:
                    const progress = Math.round(100 * event.loaded / event.total);
                    return { status: 'progress', message: progress };
                  case HttpEventType.Response:
                    return event.body;
                  default:
                    return { status: 'progress', message: event.type };
                }
              }),
            catchError(this.headerSrv._errorHandler)
        );
    }
    GetPrestonHistory(showAll: boolean = false, userUsage?: number, startDate?: string, endDate?: string){
        let Params = new HttpParams();
        Params = Params.append('all', showAll.toString());
        
        if (userUsage && startDate && endDate) {
            Params = Params.append('user_usage', userUsage.toString());
            Params = Params.append('start_date', startDate);
            Params = Params.append('end_date', endDate);
        }
        
        return this.http.get(`${this.url}/intranet/preston_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
            catchError(this.headerSrv._errorHandler)
        );
    }
    /**
     * Paginated Preston activity for the routed activity table.
     * NOTE on offset: chatService.cfc parses `offset` before `limit`, so it computes
     * startRow as (offset * 25) + 1 using the DEFAULT page size no matter what limit
     * is sent. Callers must therefore pass offset as (firstRow / 25), not the page
     * index — see fetchRows() in prestonactivity.component.ts.
     */
    GetPrestonHistoryPaginated(params: { all?: boolean, q?: string, limit?: number, offset?: number, sortOrder?: string, userUsage?: number, startDate?: string, endDate?: string }): Observable<any> {
        let Params = new HttpParams();
        Params = Params.append('all', (params.all !== undefined ? params.all : false).toString());
        if (params.q) Params = Params.append('q', params.q);
        if (params.limit !== undefined) Params = Params.append('limit', params.limit.toString());
        if (params.offset !== undefined) Params = Params.append('offset', params.offset.toString());
        if (params.sortOrder) Params = Params.append('sort_order', params.sortOrder);
        if (params.userUsage && params.startDate && params.endDate) {
            Params = Params.append('user_usage', params.userUsage.toString());
            Params = Params.append('start_date', params.startDate);
            Params = Params.append('end_date', params.endDate);
        }
        return this.http.get(`${this.url}/intranet/preston_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }
    /**
     * Paginated Chase activity. Same offset caveat as GetPrestonHistoryPaginated —
     * both actions are served by the same chatService.cfc function.
     */
    GetChaseHistoryPaginated(params: { all?: boolean, q?: string, limit?: number, offset?: number, sortOrder?: string, userUsage?: number, startDate?: string, endDate?: string }): Observable<any> {
        let Params = new HttpParams();
        Params = Params.append('all', (params.all !== undefined ? params.all : false).toString());
        if (params.q) Params = Params.append('q', params.q);
        if (params.limit !== undefined) Params = Params.append('limit', params.limit.toString());
        if (params.offset !== undefined) Params = Params.append('offset', params.offset.toString());
        if (params.sortOrder) Params = Params.append('sort_order', params.sortOrder);
        if (params.userUsage && params.startDate && params.endDate) {
            Params = Params.append('user_usage', params.userUsage.toString());
            Params = Params.append('start_date', params.startDate);
            Params = Params.append('end_date', params.endDate);
        }
        return this.http.get(`${this.url}/intranet/chase_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }
    GetRangerHistory(showAll: boolean = false, userUsage?: number, startDate?: string, endDate?: string){
        let Params = new HttpParams();
        Params = Params.append('all', showAll.toString());
        
        if (userUsage && startDate && endDate) {
            Params = Params.append('user_usage', userUsage.toString());
            Params = Params.append('start_date', startDate);
            Params = Params.append('end_date', endDate);
        }
        
        return this.http.get(`${this.url}/intranet/ranger_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }
    GetAriaHistory(showAll: boolean = false){
        let Params = new HttpParams();
        Params = Params.append('all', showAll.toString());
        return this.http.get(`${this.url}/intranet/aria_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }
    GetVoraHistory(showAll: boolean = false, section?: string){
        let Params = new HttpParams();
        Params = Params.append('all', showAll.toString());
        if (section) {
            Params = Params.append('section', section);
        }
        return this.http.get(`${this.url}/intranet/aura_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }
    GetVoraHistoryPaginated(params: { all?: boolean, section?: string, q?: string, q_field?: string, limit?: number, offset?: number, external_source?: number, sort_field?: string, sort_order?: string }): Observable<any> {
        let Params = new HttpParams();
        Params = Params.append('all', (params.all !== undefined ? params.all : true).toString());
        if (params.section) Params = Params.append('section', params.section);
        if (params.q) Params = Params.append('q', params.q);
        if (params.q_field) Params = Params.append('q_field', params.q_field);
        if (params.limit !== undefined) Params = Params.append('limit', params.limit.toString());
        if (params.offset !== undefined) Params = Params.append('offset', params.offset.toString());
        if (params.external_source !== undefined) Params = Params.append('external_source', params.external_source.toString());
        if (params.sort_field) Params = Params.append('sort_field', params.sort_field);
        if (params.sort_order) Params = Params.append('sort_order', params.sort_order);
        return this.http.get(`${this.url}/intranet/aura_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }
    GetVoraBriefHistoryPaginated(params: { q?: string, q_field?: string, limit?: number, offset?: number, sort_field?: string, sort_order?: string, view?: string }): Observable<any> {
        let Params = new HttpParams();
        if (params.q) Params = Params.append('q', params.q);
        if (params.q_field) Params = Params.append('q_field', params.q_field);
        if (params.limit !== undefined) Params = Params.append('limit', params.limit.toString());
        if (params.offset !== undefined) Params = Params.append('offset', params.offset.toString());
        if (params.sort_field) Params = Params.append('sort_field', params.sort_field);
        if (params.sort_order) Params = Params.append('sort_order', params.sort_order);
        if (params.view) Params = Params.append('view', params.view);
        return this.http.get(`${this.url}/intranet/vora_brief_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }
    GetVoraBriefHistoryById(brief_id: string | number): Observable<any> {
        let Params = new HttpParams();
        Params = Params.append('open_history', String(brief_id));
        return this.http.get(`${this.url}/intranet/vora_brief_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }
    GetBrief2Pools(page: number = 1, offset: number = 25, playground?: boolean): Observable<any> {
        let Params = new HttpParams();
        Params = Params.append('page', page.toString());
        Params = Params.append('offset', offset.toString());
        if (playground === true) {
            Params = Params.append('playground', 'true');
        }
        return this.http.get(`${this.url}/intranet/brief2_pools`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }
    GetVoraChatList(params: { limit?: number, offset?: number, q?: string, sortBy?: string, sortOrder?: string, excludeRequestTypes?: string, excludeCompanyId?: number, channel?: string, status?: string, sourceKey?: string, companyId?: number }): Observable<any> {
        let Params = new HttpParams();
        if (params.limit !== undefined) Params = Params.append('limit', params.limit.toString());
        if (params.offset !== undefined) Params = Params.append('offset', params.offset.toString());
        if (params.q) Params = Params.append('q', params.q);
        if (params.sortBy) Params = Params.append('sortBy', params.sortBy);
        if (params.sortOrder) Params = Params.append('sortOrder', params.sortOrder);
        if (params.excludeRequestTypes) Params = Params.append('excludeRequestTypes', params.excludeRequestTypes);
        if (params.excludeCompanyId !== undefined) Params = Params.append('excludeCompanyId', params.excludeCompanyId.toString());
        if (params.channel) Params = Params.append('channel', params.channel);
        if (params.status) Params = Params.append('status', params.status);
        if (params.sourceKey) Params = Params.append('sourceKey', params.sourceKey);
        if (params.companyId !== undefined) Params = Params.append('companyId', params.companyId.toString());
        return this.http.get(`${environment.voraNestPath}/admin/vora-chat`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }

    /** Distinct sources + companies for the ASK 2.0 column dropdowns. The table
     *  is server-side paginated, so the options cannot come from the loaded page
     *  — they would only ever list what happened to be on screen. */
    GetVoraChatFilterOptions(params: { excludeCompanyId?: number, excludeRequestTypes?: string }): Observable<any> {
        let Params = new HttpParams();
        if (params.excludeCompanyId !== undefined) Params = Params.append('excludeCompanyId', params.excludeCompanyId.toString());
        if (params.excludeRequestTypes) Params = Params.append('excludeRequestTypes', params.excludeRequestTypes);
        return this.http.get(`${environment.voraNestPath}/admin/vora-chat/filters`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }
    GetVoraChatSession(sessionId: string): Observable<any> {
        return this.http.get(`${environment.voraNestPath}/admin/vora-chat/session/${sessionId}`, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }
    GetChaseHistory(showAll: boolean = false, userUsage?: number, startDate?: string, endDate?: string){
        let Params = new HttpParams();
        Params = Params.append('all', showAll.toString());
        
        if (userUsage && startDate && endDate) {
            Params = Params.append('user_usage', userUsage.toString());
            Params = Params.append('start_date', startDate);
            Params = Params.append('end_date', endDate);
        }
        
        return this.http.get(`${this.url}/intranet/chase_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }
    GetRoverHistory(showAll: boolean = false, userUsage?: number, startDate?: string, endDate?: string){
        let Params = new HttpParams();
        Params = Params.append('all', showAll.toString());
        
        if (userUsage && startDate && endDate) {
            Params = Params.append('user_usage', userUsage.toString());
            Params = Params.append('start_date', startDate);
            Params = Params.append('end_date', endDate);
        }
        
        return this.http.get(`${this.url}/intranet/rover_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
            catchError(this.headerSrv._errorHandler)
        );
    }
    GetRoverHistoryBySessionId(session_id: string){
        let Params = new HttpParams();
        Params = Params.append('open_history', session_id);
        Params = Params.append('all', 'true');
        return this.http.get(`${this.url}/intranet/rover_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
            catchError(this.headerSrv._errorHandler)
        );
    }
    GetPrestonHistoryBySessionId(session_id: string){
        let Params = new HttpParams();
        Params = Params.append('open_history', session_id);
        Params = Params.append('all', 'true');
        return this.http.get(`${this.url}/intranet/preston_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
            catchError(this.headerSrv._errorHandler)
        );
    }
    GetRangerHistoryBySessionId(session_id: string){
        let Params = new HttpParams();
        Params = Params.append('open_history', session_id);
        Params = Params.append('all', 'true');
        return this.http.get(`${this.url}/intranet/ranger_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
            catchError(this.headerSrv._errorHandler)
        );
    }
    GetAriaHistoryBySessionId(session_id: string){
        let Params = new HttpParams();
        Params = Params.append('open_history', session_id);
        Params = Params.append('all', 'true');
        return this.http.get(`${this.url}/intranet/aria_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
            catchError(this.headerSrv._errorHandler)
        );
    }
    GetVoraHistoryBySessionId(session_id: string){
        let Params = new HttpParams();
        Params = Params.append('open_history', session_id);
        Params = Params.append('all', 'true');
        return this.http.get(`${this.url}/intranet/aura_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
            catchError(this.headerSrv._errorHandler)
        );
    }
    GetChaseHistoryBySessionId(session_id: string){
        let Params = new HttpParams();
        Params = Params.append('open_history', session_id);
        Params = Params.append('all', 'true');
        return this.http.get(`${this.url}/intranet/chase_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
            catchError(this.headerSrv._errorHandler)
        );
    }
    GetPrestonAdminPromptKeys(){
        let Params = new HttpParams();
        Params = Params.append('available_keys', 'true');
        return this.http.get(`${this.url}/intranet/preston_prompt`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    GetChaseAdminPromptKeys(){
        let Params = new HttpParams();
        Params = Params.append('available_keys', 'true');
        return this.http.get(`${this.url}/intranet/chase_prompt`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    GetRangerAdminPromptKeys(){
        let Params = new HttpParams();
        Params = Params.append('available_keys', 'true');
        return this.http.get(`${this.url}/intranet/ranger_prompt`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    GetAriaAdminPromptKeys(){
        let Params = new HttpParams();
        Params = Params.append('available_keys', 'true');
        return this.http.get(`${this.url}/intranet/aria_prompt`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    ChatWithAITeammate(chatBody:{session_id: string, prompt: string, files?: File[], isQuestion?: boolean}){
        const prompt_channel = {"id":3964233,"name":"OpenAI o4-mini"};
        let body:{prompt: string, prompt_channel: {id: number, name: string}, sessionId: string, files?: File[], isQuestion?: boolean} = {
            prompt: chatBody.prompt,
            prompt_channel: prompt_channel,
            sessionId: chatBody.session_id
        };
        if(chatBody.files && chatBody.files.length){
            body.files = chatBody.files;
        }
        if(chatBody.isQuestion){
            body.isQuestion = chatBody.isQuestion;
        }
        return this.http.post(`${this.url}/intranet/chat_new`, body, {headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    WeeklyUsage(){
        return this.http.get(`${this.url}/intranet/teamai_weekly_report`, {headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    LookUpExistingClientByEmail(email: string){
        let Params = new HttpParams();  
        Params = Params.append('email', email);
        return this.http.get(`${this.url}/intranet/email_lookup`, {params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    GetChaseTranscript(session_id: string){
        let Params = new HttpParams();
        Params = Params.append('session_id', session_id);
        return this.http.get(`${this.url}/intranet/get_transcript`, {params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    GetHunterResult(){
        return this.http.get(`${this.url}/intranet/get_hunter_result`, {headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Fetches all RoverOptions (companyid, active status, and name)
     * @param query - The search query string
     * @returns Observable with rover options data
     */
    GetRoverOptions(query: string){
        let Params = new HttpParams();
        Params = Params.append('q', query);
        return this.http.get(`${this.url}/intranet/get_rover_options`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Fetches the result of the Rover search
     * @param query - The search query string
     * @returns Observable with rover result data
     */
    GetRoverResult(query: string){
        let Params = new HttpParams();
        Params = Params.append('q', query);
        return this.http.get(`${this.url}/intranet/get_rover_result`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Fetches the prompts for the Rover search
     * @returns Observable with rover prompts data
     */
    GetRoverPrompts() {
        let Params = new HttpParams();
        Params = Params.append('system', 'true');
        return this.http.get(`${this.url}/intranet/rover_prompt`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler))
    }

    /**
     * Adds, edits, or deletes a Rover prompt
     * @param action - The action to perform ('add', 'update', or 'delete')
     * @param body - The body of the prompt
     * @returns Observable with rover prompt data
     */
    AddEditRoverPrompt(action: string, body: any){
        if(action === 'add'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.post(`${this.url}/intranet/rover_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else if(action === 'update'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.put(`${this.url}/intranet/rover_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else {
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            const httpOptions = {
                headers: this.headerSrv.returnHeader(),
                body: JSON.stringify(body),
                params: Params
            };
            return this.http.delete(`${this.url}/intranet/rover_prompt`, httpOptions).pipe(catchError(this.headerSrv._errorHandler));
        }
    }
    PostRoverPromptToAI(formCopy: {id: number, text: string, get_rover_result: any, company_name: string}){
        const body: {id: number, text: string, get_rover_result: any, company: string} = {
            id: formCopy.id,
            text: formCopy.text,
            get_rover_result: formCopy.get_rover_result,
            company: formCopy.company_name
        }
        return this.http.post(`${this.url}/intranet/rover_prompt`, body, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    GetRoverAdminPromptKeys(){
        let Params = new HttpParams();
        Params = Params.append('available_keys', 'true');
        return this.http.get(`${this.url}/intranet/rover_prompt`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    GetPrestonHistoryByQuery(query: string, showAll: boolean = false){
        let Params = new HttpParams();
        Params = Params.append('q', query);
        Params = Params.append('all', showAll.toString());
        return this.http.get(`${this.url}/intranet/preston_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    GetChaseHistoryByQuery(query: string, showAll: boolean = false){
        let Params = new HttpParams();
        Params = Params.append('q', query);
        Params = Params.append('all', showAll.toString());
        return this.http.get(`${this.url}/intranet/chase_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    GetRoverHistoryByQuery(query: string, showAll: boolean = false){
        let Params = new HttpParams();
        Params = Params.append('q', query); 
        Params = Params.append('all', showAll.toString());
        return this.http.get(`${this.url}/intranet/rover_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    GetRangerHistoryByQuery(query: string, showAll: boolean = false){
        let Params = new HttpParams();
        Params = Params.append('q', query);
        Params = Params.append('all', showAll.toString());
        return this.http.get(`${this.url}/intranet/ranger_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    GetAriaHistoryByQuery(query: string, showAll: boolean = false){
        let Params = new HttpParams();
        Params = Params.append('q', query);
        Params = Params.append('all', showAll.toString());
        return this.http.get(`${this.url}/intranet/aria_history`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    
    /**
     * Chat with AI teammates using feed items
     * @param prompt - User's chat prompt
     * @param ids - Optional comma delimited string of feed item IDs
     * @param sessionId - Optional session ID for continuing chat
     * @returns Observable with chat response
     */
    PostTeammatesFeedChat(prompt: string, ids?: string, sessionId?: string){
        const body: FormData = new FormData();
        body.append('Prompt', prompt);
        
        if (ids) {
            body.append('Ids', ids);
        }
        
        if (sessionId) {
            body.append('session_id', sessionId);
        }
        
        return this.http.post(`${this.url}/intranet/teammates_feed_chat`, body, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    
    GetSysPrompt(){
        return this.http.get(`${this.url}/intranet/sys_prompt`, {headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    AddEditSysPrompt(action: string, body: any){
        if(action === 'add'){
            let Params = new HttpParams();
            return this.http.post(`${this.url}/intranet/sys_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else if(action === 'update'){
            let Params = new HttpParams();
            return this.http.put(`${this.url}/intranet/sys_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else {
            let Params = new HttpParams();
            const httpOptions = {
                headers: this.headerSrv.returnHeader(),
                body: JSON.stringify(body),
                params: Params
            };
            return this.http.delete(`${this.url}/intranet/sys_prompt`, httpOptions).pipe(catchError(this.headerSrv._errorHandler));
        }
    }
    GetPrePrompt(){
        return this.http.get(`${this.url}/intranet/pre_prompt`, {headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    AddEditPrePrompt(action: string, body: any){
        if(action === 'add'){
            let Params = new HttpParams();
            return this.http.post(`${this.url}/intranet/pre_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else if(action === 'update'){
            let Params = new HttpParams();
            return this.http.put(`${this.url}/intranet/pre_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else {
            let Params = new HttpParams();
            const httpOptions = {
                headers: this.headerSrv.returnHeader(),
                body: JSON.stringify(body),
                params: Params
            };
            return this.http.delete(`${this.url}/intranet/pre_prompt`, httpOptions).pipe(catchError(this.headerSrv._errorHandler));
        }
    }
    AITeamMatesEditPromptTitle(session_id: string, id: number, title: string){
        let Params = new HttpParams();
        Params = Params.append('id', id.toString());
        Params = Params.append('session_id', session_id);
        Params = Params.append('title', title);
        return this.http.get(`${this.url}/intranet/edit_prompt_title`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    SendToSkyNetTeamsTab(id: string){
        let Params = new HttpParams();
        Params = Params.append('id', id);
        return this.http.get(`${this.url}/intranet/send_to_skynet`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
            catchError(this.headerSrv._errorHandler)
        );
    }

    PostPrePromptTest(formData: {source: string, id: number, transcript?: any[]}){
        return this.http.post(`${this.url}/intranet/pre_prompt_test`, formData, {headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Get AI Teammates Feed with lazy loading support
     * @param myFeed - Get only my history if true
     * @param lastFeedCut - Tick from previous response for lazy loading
     * @param numberOfRows - Number of rows to fetch (default 50)
     * @returns Observable with feed data
     */
    GetTeammatesFeed(myFeed?: boolean, lastFeedCut?: number, numberOfRows: number = 50) {
        let Params = new HttpParams();
        if (myFeed !== undefined && myFeed !== null) {
            Params = Params.append('my_feed', myFeed.toString());
        }
        if (lastFeedCut !== undefined && lastFeedCut !== null) {
            Params = Params.append('last_feed_cut', lastFeedCut.toString());
        }
        Params = Params.append('number_of_rows', numberOfRows.toString());
        return this.http.get(`${this.url}/intranet/teammates_feed`, { params: Params, headers: this.headerSrv.returnHeader()}).pipe(catchError(this.headerSrv._errorHandler));
    }
    /**
     * Get AI Teammates Feed with search support
     * @param query - The search query string
     * @param ai_team_mate - The AI team mate
     * @returns Observable with feed data
     */
    GetTeammatesFeedSearch(query: string, ai_team_mate?: string) {
        let Params = new HttpParams();
        if (query !== undefined && query !== null) {
            Params = Params.append('query', query);
        }
        if (ai_team_mate !== undefined && ai_team_mate !== null) {
            Params = Params.append('ai_team_mate', ai_team_mate);
        }
        return this.http.get(`${this.url}/intranet/teammates_feed_search`, { params: Params, headers: this.headerSrv.returnHeader()}).pipe(catchError(this.headerSrv._errorHandler));
    }

    // AI Assessment Methods
    GetAIAssessments() {
        return this.http.get(`${this.url}/intranet/ai_assessment`, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    AddEditAIAssessment(action: string, body: any) {
        if (action === 'add') {
            return this.http.post(`${this.url}/intranet/ai_assessment`, JSON.stringify(body), { headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        } else if (action === 'update') {
            return this.http.put(`${this.url}/intranet/ai_assessment`, JSON.stringify(body), { headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        } else {
            const httpOptions = {
                headers: this.headerSrv.returnHeader(),
                body: JSON.stringify(body)
            };
            return this.http.delete(`${this.url}/intranet/ai_assessment`, httpOptions).pipe(catchError(this.headerSrv._errorHandler));
        }
    }

    GetAIAssessmentFrequencies() {
        return this.http.get(`${this.url}/intranet/ai_assessment_frequency`, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    GetAIAssessmentStatuses() {
        return this.http.get(`${this.url}/intranet/ai_assessment_status`, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    GetAssessmentTypes() {
        return this.http.get(`${this.url}/intranet/assessment_type`, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * AI Assessment Prompt CRUD
     * Fields: title, system_prompt (User Prompt), knowledge_base_prompt
     * GET/POST/PUT/DELETE: /intranet/ai_assessment_prompt
     */
    GetAIAssessmentPrompts() {
        let Params = new HttpParams();
        Params = Params.append('system', 'true');
        return this.http.get(`${this.url}/intranet/ai_assessment_prompt`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    AddEditAIAssessmentPrompt(action: 'add' | 'update' | 'delete', body: { id?: number, version?: string, name?: string, prompt?: string, knowledge_base_prompt?: string }){
        if(action === 'add'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.post(`${this.url}/intranet/ai_assessment_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else if(action === 'update'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.put(`${this.url}/intranet/ai_assessment_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else {
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            const httpOptions = {
                headers: this.headerSrv.returnHeader(),
                body: JSON.stringify(body),
                params: Params
            };
            return this.http.delete(`${this.url}/intranet/ai_assessment_prompt`, httpOptions).pipe(catchError(this.headerSrv._errorHandler));
        }
    }

    /**
     * Company options for AI Assessment (search)
     * GET: /intranet/ai_assessment_company?q=
     */
    GetAIAssessmentCompanies(query: string){
        let Params = new HttpParams();
        Params = Params.append('q', query);
        return this.http.get(`${this.url}/intranet/ai_assessment_company`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Test AI Assessment
     * POST: /intranet/ai_assessment_test
     */
    TestAIAssessment(body: any) {
        return this.http.post(`${this.url}/intranet/ai_assessment_test`, JSON.stringify(body), { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    
    /**
     * Get Test AI Assessment Results
     * GET: /intranet/ai_assessment_jobs
     */
    GetTestAIAssessmentJobs() {
        return this.http.get(`${this.url}/intranet/ai_assessment_jobs`, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Post AI Assessment Test Weekly
     * POST: /intranet/ai_assessment_test_weekly
     */
    PostAIAssessmentTestWeekly(formData: {session_id: string, prompt: {id: number}}){
        const body: {session_id: string, prompt: {id: number}} = {
            session_id: formData.session_id,
            prompt: {
                id: formData.prompt.id
            }
        }
        return this.http.post(`${this.url}/intranet/ai_assessment_test_weekly`, JSON.stringify(body), { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Get AI Assessment Jobs V2 (Rover Playground Dashboard)
     * GET: /intranet/ai_assessment_jobs_v2
     * @returns Observable with AI assessment jobs v2 data
     */
    GetAIAssessmentJobsV2() {
        return this.http.get(`${this.url}/intranet/ai_assessment_jobs_v2`, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }
    /**
     * Get AI Assessment Jobs V2 Production (Rover 2.0)
     * GET: /intranet/ai_assessment_jobs_v2?production=true
     * @returns Observable with AI assessment jobs v2 data
     */
    GetAIAssessmentJobsV2Production() {
        let Params = new HttpParams();
        Params = Params.append('production', 'true');
        return this.http.get(`${this.url}/intranet/ai_assessment_jobs_v2`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Get AI Assessment Jobs V2 Detail (Rover Playground Dashboard)
     * GET: /intranet/ai_assessment_jobs_v2_detail
     * @param session_id - The id of weekly or annually assessment
     * @returns Observable with AI assessment jobs v2 detail data
     */
    GetAIAssessmentJobsV2Detail(session_id: string) {
        let Params = new HttpParams();
        Params = Params.append('id', session_id);
        return this.http.get(`${this.url}/intranet/ai_assessment_jobs_v2_detail`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Post AI Assessment Chats
     * POST: /intranet/ai_assessment_chats
     * Body: { Prompt: string, MetaAnalysis?: boolean }
     * Optional production flag: ?production=true
     */
    PostAIAssessmentChats(prompt: string, production?: boolean, metaAnalysis?: boolean){
        const body: any = { Prompt: prompt };
        
        // Add MetaAnalysis to body if true
        if (metaAnalysis) {
            body.MetaAnalysis = true;
        }
        
        const options: { headers: any, params?: HttpParams } = { headers: this.headerSrv.returnHeader() };
        
        // Only create params if production flag is true
        if (production) {
            let Params = new HttpParams();
            Params = Params.append('production', 'true');
            options.params = Params;
        }
        
        return this.http.post(`${this.url}/intranet/ai_assessment_chats`, JSON.stringify(body), options).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Get AI Assessment Chats
     * GET: /intranet/ai_assessment_chats
     * Optional production flag: ?production=true
     */
    GetAIAssessmentChats(production?: boolean){
        let options: { headers: any, params?: HttpParams } = { headers: this.headerSrv.returnHeader() };
        if (production) {
            let Params = new HttpParams();
            Params = Params.append('production', 'true');
            options.params = Params;
        }
        return this.http.get(`${this.url}/intranet/ai_assessment_chats`, options).pipe(catchError(this.headerSrv._errorHandler));
    }
    /**
     * Get AI Assessment Chats
     * GET: /intranet/ai_assessment_chats
     * Optional production flag: ?production=true
     */
    GetAIAssessmentChatsMetaAnalysis(production?: boolean){
        let options: { headers: any, params?: HttpParams } = { headers: this.headerSrv.returnHeader() };
        if (production) {
            let Params = new HttpParams();
            Params = Params.append('production', 'true');
            Params = Params.append('MetaAnalysis', 'true');
            options.params = Params;
        }
        return this.http.get(`${this.url}/intranet/ai_assessment_chats`, options).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * ============================================
     * VERA PLAYGROUND METHODS (QC Report Checking)
     * ============================================
     */

    /**
     * Get Tessa Jobs V2 (Tessa Playground Dashboard)
     * GET: /intranet/vera_jobs_v2
     * @returns Observable with Tessa QC report data
     */
    GetTessaJobsV2() {
        return this.http.get(`${this.url}/intranet/vera_jobs_v2`, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Get Tessa Statuses
     * GET: /intranet/vera_status
     * @returns Observable with Tessa status options
     */
    GetTessaStatuses() {
        return this.http.get(`${this.url}/intranet/vera_status`, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Get Tessa Prompts
     * GET: /intranet/vera_prompt?system=true
     * @returns Observable with Tessa prompt configurations
     */
    GetTessaPrompts() {
        let Params = new HttpParams();
        Params = Params.append('system', 'true');
        return this.http.get(`${this.url}/intranet/vera_prompt`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Add/Edit/Delete Tessa Prompt
     * POST/PUT/DELETE: /intranet/vera_prompt?system=true
     * @param action - 'add' | 'update' | 'delete'
     * @param body - Prompt data with id, version, name, prompt, knowledge_base_prompt
     * @returns Observable
     */
    AddEditTessaPrompt(action: 'add' | 'update' | 'delete', body: { id?: number, version?: string, name?: string, prompt?: string, knowledge_base_prompt?: string, forcerun?: boolean }){
        if(action === 'add'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.post(`${this.url}/intranet/vera_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else if(action === 'update'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.put(`${this.url}/intranet/vera_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else {
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            const httpOptions = {
                headers: this.headerSrv.returnHeader(),
                body: JSON.stringify(body),
                params: Params
            };
            return this.http.delete(`${this.url}/intranet/vera_prompt`, httpOptions).pipe(catchError(this.headerSrv._errorHandler));
        }
    }

    /**
     * Add/Edit/Delete Tessa Meta (License Configuration)
     * POST/PUT/DELETE: /intranet/vera_meta
     * @param action - 'add' | 'update' | 'delete'
     * @param body - Meta data with id, name, license, status, prompt
     * @returns Observable
     */
    AddEditTessaMeta(action: string, body: any) {
        if (action === 'add') {
            return this.http.post(`${this.url}/intranet/vera_meta`, JSON.stringify(body), { headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        } else if (action === 'update') {
            return this.http.put(`${this.url}/intranet/vera_meta`, JSON.stringify(body), { headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        } else {
            const httpOptions = {
                headers: this.headerSrv.returnHeader(),
                body: JSON.stringify(body)
            };
            return this.http.delete(`${this.url}/intranet/vera_meta`, httpOptions).pipe(catchError(this.headerSrv._errorHandler));
        }
    }

    /**
     * Get Tessa Licenses (search for license options)
     * GET: /intranet/vera_license?q=
     * @param query - Search query string
     * @returns Observable with license options
     */
    GetTessaLicenses(query: string){
        let Params = new HttpParams();
        Params = Params.append('q', query);
        return this.http.get(`${this.url}/intranet/vera_license`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Get Tessa Jobs V2 Detail (Tessa Playground Detail View)
     * GET: /intranet/vera_jobs_v2_detail
     * @param session_id - The session ID of the QC report
     * @returns Observable with Tessa job detail data
     */
    GetTessaJobsV2Detail(session_id: string) {
        let Params = new HttpParams();
        Params = Params.append('id', session_id);
        return this.http.get(`${this.url}/intranet/vera_jobs_v2_detail`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Post Tessa Chats
     * POST: /intranet/vera_chats
     * Body: { Prompt: string }
     * @param prompt - Chat prompt message
     * @returns Observable
     */
    PostTessaChats(prompt: string){
        const body: any = { Prompt: prompt };
        return this.http.post(`${this.url}/intranet/vera_chats`, JSON.stringify(body), { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Get Tessa Chats
     * GET: /intranet/vera_chats
     * @returns Observable with Tessa chat history
     */
    GetTessaChats(){
        return this.http.get(`${this.url}/intranet/vera_chats`, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Test Tessa (Generate QC Report)
     * POST: /intranet/vera_test
     * @param body - Test data with id, license, etc.
     * @returns Observable
     */
    TestTessa(body: any) {
        return this.http.post(`${this.url}/intranet/vera_test`, JSON.stringify(body), { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Get Comply Chats (Vera Playground - Comply)
     * GET: /intranet/comply_chats?type=clients
     * @param type - Filter type: 'clients' (default), 'agent', 'internalExceptions', or 'all'
     * @returns Observable with comply chats data
     */
    GetComplyChats(type: string = 'clients') {
        let Params = new HttpParams();
        Params = Params.append('type', type);
        return this.http.get(`${this.url}/intranet/comply_chats`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Get Comply Prompts
     * GET: /intranet/comply_prompt?system=true
     * @returns Observable with Comply prompt configurations
     */
    GetComplyPrompts() {
        let Params = new HttpParams();
        Params = Params.append('system', 'true');
        return this.http.get(`${this.url}/intranet/comply_prompt`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Add/Edit/Delete Comply Prompt
     * POST/PUT/DELETE: /intranet/comply_prompt?system=true
     * @param action - 'add' | 'update' | 'delete'
     * @param body - Prompt data with id, version, name, prompt, knowledge_base_prompt, model_id, active
     * @returns Observable
     */
    AddEditComplyPrompt(action: 'add' | 'update' | 'delete', body: { id?: number, version?: string, name?: string, prompt?: string, knowledge_base_prompt?: string, model_id?: number, active?: number }){
        if(action === 'add'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.post(`${this.url}/intranet/comply_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else if(action === 'update'){
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            return this.http.put(`${this.url}/intranet/comply_prompt`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
                catchError(this.headerSrv._errorHandler));
        }else {
            let Params = new HttpParams();
            Params = Params.append('system', 'true');
            const httpOptions = {
                headers: this.headerSrv.returnHeader(),
                body: JSON.stringify(body),
                params: Params
            };
            return this.http.delete(`${this.url}/intranet/comply_prompt`, httpOptions).pipe(catchError(this.headerSrv._errorHandler));
        }
    }

    /**
     * Grade Comply Chat
     * POST: /intranet/comply_grading?id=
     * @param id - The ID of the comply chat to grade
     * @returns Observable
     */
    GradeComplyChat(id: string) {
        let Params = new HttpParams();
        Params = Params.append('id', id);
        return this.http.post(`${this.url}/intranet/comply_grading`, JSON.stringify({}), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    GetCompanyBranches() {
        return this.http.get(`${this.url}/serviceman/getCOBranches`, { headers: this.headerSrv.returnHeader() }).pipe(
            catchError(this.headerSrv._errorHandler));
    }

    GetMapTemplates() {
        return this.http.get(`${this.url}/serviceman/getmyinteltemplates`, { headers: this.headerSrv.returnHeader() }).pipe(
            catchError(this.headerSrv._errorHandler));
    }

    GetAllReportFrequencies() {
        return this.http.get(`${this.url}/serviceman/getreportfreq`, { headers: this.headerSrv.returnHeader() }).pipe(
            catchError(this.headerSrv._errorHandler));
    }

    /**
     * Post Vora Prompt Brief
     * POST: /intranet/vora_prompt_brief
     * @param formData - Object containing mapId, agent, intranetId, and optionally template, frequency, prompt
     * @param html - Optional flag to return HTML response
     * @param preview - Optional flag to enable preview mode (adds preview=true)
     * @param html2 - Optional flag for Claude preview (adds html2=true)
     * @returns Observable
     */
    PostVoraPromptBrief(
        formData: {mapId: number, agent: string, intranetId: number, template?: number, frequency?: number, prompt?: string, model?: number},
        html?: boolean,
        preview?: boolean,
        html2?: boolean
    ){
        const body: any = {
            mapId: formData.mapId,
            agent: formData.agent,
            intranetId: formData.intranetId
        };
        if (formData.template !== undefined) {
            body.template = formData.template;
        }
        if (formData.frequency !== undefined) {
            body.frequency = formData.frequency;
        }
        if (formData.prompt) {
            body.prompt = formData.prompt;
        }
        if (formData.model !== undefined) {
            body.model = formData.model;
        }
        let Params = new HttpParams();
        if (typeof html === 'boolean') {
            Params = Params.append('html', html ? 'true' : 'false');
        }
        if (typeof preview === 'boolean') {
            Params = Params.append('preview', preview ? 'true' : 'false');
        }
        if (typeof html2 === 'boolean') {
            Params = Params.append('html2', html2 ? 'true' : 'false');
        }
        return this.http.post(`${this.url}/intranet/vora_prompt_brief`, JSON.stringify(body), { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Get Vora Prompt Brief Agents
     * GET: /intranet/vora_prompt_brief_agents
     * @returns Observable
     */
    GetVoraPromptBriefAgents(){
        return this.http.get(`${this.url}/intranet/vora_prompt_brief_agents`, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Post Brief 2.0 Testing (Vora Brief 2 Playground entry submit)
     * POST: /intranet/brief2_testing
     * Body: { mapId, agent (comma-delimited), intranetId, frequency, note? }
     * @param formData - Object containing mapId, agent, intranetId, frequency, and optional note
     * @returns Observable
     */
    PostBrief2Testing(formData: {mapId: number, agent: string, intranetId: number, frequency: number, note?: string}){
        const body: any = {
            mapId: formData.mapId,
            agent: formData.agent,
            intranetId: formData.intranetId,
            frequency: formData.frequency
        };
        if (formData.note) {
            body.note = formData.note;
        }
        return this.http.post(`${this.url}/intranet/brief2_testing`, JSON.stringify(body), { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    getSearchSuggest(keyword, type) {
        let Params = new HttpParams();
        Params = Params.append('q', keyword);
        Params = Params.append('type', type);
        Params = Params.append('brief', 'true');
        return this.http.get(`${this.url}/serviceman/searchsuggest`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(
            catchError(this.headerSrv._errorHandler))
    }

    /**
     * Post Vora Demo
     * POST: /intranet/vora_demo
     * Body: { mapId: number, intranetId: number, agent: string, prompt?: string }
     * @param formData - Object containing mapId, intranetId, agent (comma-delimited IDs), and optional prompt
     * @returns Observable with Vora demo response
     */
    PostVoraDemo(formData: {mapId: number, intranetId: number, agent: string, prompt?: string, model?: number}){
        const body: any = {
            mapId: formData.mapId,
            intranetId: formData.intranetId,
            agent: formData.agent
        };
        if (formData.prompt) {
            body.prompt = formData.prompt;
        }
        if (formData.model !== undefined) {
            body.model = formData.model;
        }
        return this.http.post(`${this.url}/intranet/vora_demo`, JSON.stringify(body), { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Get Vora Maps (for autocomplete/search)
     * GET: /intranet/vora_maps
     * @param query - Optional search query string
     * @returns Observable with vora maps data
     */
    GetVoraMaps(query?: string){
        let Params = new HttpParams();
        if (query) {
            Params = Params.append('q', query);
        }
        return this.http.get(`${this.url}/intranet/vora_maps`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Get Vora User Branch Maps
     * GET: /intranet/vora_user_branchmaps
     * @param query - Search query string
     * @param playground - Optional flag to indicate playground usage
     * @returns Observable with user data including maps and branches
     */
    GetVoraUserBranchMap(query: string, playground?: boolean){
        let Params = new HttpParams();
        Params = Params.append('q', query);
        if (playground === true) {
            Params = Params.append('playground', 'true');
        }
        return this.http.get(`${this.url}/intranet/vora_user_branchmaps`, { params: Params, headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * How the source check performed over the last N days — PASS / FLAG / STRIP / BLACKLIST counts
     * across every VORA client, for the "why we are different" panel.
     *
     * Same host as the scorecard, and the same reason for it: the API returns the verdicts and the
     * panel does the one subtraction it needs, rather than each screen inventing its own rate.
     */
    GetTrustedSourcesVerdicts(days: number = 30): Observable<any> {
        return this.http.get(`${environment.trustedSourcesPath}/api/interaction-metrics/global/source-verdicts?days=${days}`, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * What VORA has refused, to date and this week.
     *
     * Counted as citations blocked, not domains — a domain count would be a claim about the
     * present, and most domains VORA once refused have since been reviewed and approved. A blocked
     * citation is a thing that happened, so the number only ever accumulates.
     */
    GetBlockedSummary(): Observable<any> {
        return this.http.get(`${environment.trustedSourcesPath}/api/source-audit/blocked-summary`, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * What the source check did per delivery channel, last N days — for the "why we are different"
     * panel.
     *
     * Returns counts ready to render and ONE overall rate. The exclusions live server-side on
     * purpose: `out-of-window` is the freshness gate (digests only, and it drops sources that
     * already passed the trust check), and per-channel rates are not stable enough to publish.
     * A screen that re-derived either would disagree with the API the first time one of them moved.
     */
    GetSourceCheckByChannel(days: number = 7): Observable<any> {
        return this.http.get(`${environment.trustedSourcesPath}/api/source-audit/by-channel?days=${days}`, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * The Trusted Sources scorecard — how many sources we trust, how many we reject, and how each
     * moved over the last 7 and 30 days.
     *
     * Different host to everything else in this service: Trusted Sources is its own service, so
     * this uses `environment.trustedSourcesPath` rather than `this.url`, the same way
     * OverviewService reaches the Ask ADA prefill/sync endpoints.
     *
     * The four numbers are computed server-side on purpose. The API returns them ready to render so
     * no screen does its own arithmetic — two surfaces doing the same sum is how they end up
     * disagreeing in front of a client.
     */
    GetTrustedSourcesScorecard(): Observable<any> {
        return this.http.get(`${environment.trustedSourcesPath}/api/trusted-sources/trust-scorecard`, { headers: this.headerSrv.returnHeader() }).pipe(catchError(this.headerSrv._errorHandler));
    }

    /**
     * Get Vora Stream SSE endpoint URL
     * Used with native fetch() for streaming responses
     * @returns Full URL to the SSE streaming endpoint
     */
    getVoraStreamUrl(): string {
        // TODO: revert to ${this.url} for production
        return `${this.url}/intranet/vora_demo_stream`;
    }
}